import apiClient, { extractData } from "./client";

export async function getRequests(params = {}) {
  const response = await apiClient.get("/requests", { params });
  return extractData(response);
}

export async function getRequest(id) {
  const response = await apiClient.get(`/requests/${id}`);
  return extractData(response);
}

export async function getRequestHistory(id) {
  const response = await apiClient.get(`/requests/${id}/history`);
  return extractData(response);
}

export async function createRequest(data) {
  const response = await apiClient.post("/requests", data);
  return extractData(response);
}

export async function approveRequest(id, data = {}) {
  const response = await apiClient.post(`/requests/${id}/approve`, data);
  return extractData(response);
}

export async function rejectRequest(id, data = {}) {
  const response = await apiClient.post(`/requests/${id}/reject`, data);
  return extractData(response);
}

export async function closeRequest(id, data = {}) {
  const response = await apiClient.post(`/requests/${id}/close`, data);
  return extractData(response);
}
